import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useMarque } from './useMarque';

/**
 * Rappel de l'aperçu en cours (TF-436), au-dessus de tout écran : la personne
 * qui règle la marque parcourt la plateforme habillée du brouillon, que
 * personne d'autre ne voit tant qu'il n'est pas appliqué.
 */
export function BandeauApercuMarque(): JSX.Element | null {
  const { apercu, arreterApercu } = useMarque();
  if (!apercu) return null;
  return (
    <div
      role="status"
      className="sticky top-0 z-30 flex flex-col gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-900 sm:flex-row sm:items-center sm:justify-between sm:px-6"
    >
      <div className="flex min-w-0 items-start gap-2">
        <Eye className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="min-w-0">
          Aperçu de la marque « {apercu.marque.nom} » : visible de vous seul(e), rien n’est appliqué.
        </span>
      </div>
      <div className="flex shrink-0 flex-wrap gap-2">
        <Link
          to="/dir-parametres?onglet=marque"
          className="inline-flex min-h-[40px] items-center rounded-lg bg-white px-3 text-xs font-semibold text-amber-900 ring-1 ring-amber-200 hover:bg-amber-100"
        >
          Revenir au réglage
        </Link>
        <button
          type="button"
          onClick={arreterApercu}
          className="inline-flex min-h-[40px] items-center rounded-lg px-3 text-xs font-semibold text-amber-900 hover:bg-amber-100"
        >
          Quitter l’aperçu
        </button>
      </div>
    </div>
  );
}
